/**
 * Cleans a URL by removing duplicate forward slashes, except after a colon.
 *
 * This function uses a regular expression to find instances of two or more
 * consecutive forward slashes that are not preceded by a colon. It then
 * replaces these with a single forward slash.
 *
 * @param {string} str - The URL string to be cleaned.
 * @returns {string} The cleaned URL with duplicate slashes removed.
 *
 * @example
 * CleanUrl("http://example.com//path///to//file") // Returns "http://example.com/path/to/file"
 * CleanUrl("file:///home//user///document") // Returns "file:///home/user/document"
 */
export const CleanUrl = (str) => {
	const regex = /([^:])(\/\/+)/g;
	let cleanStr;
	cleanStr = str.replace(regex, '$1/');
	return cleanStr;
};
